export function appendQueryToShopifyImageUrl(propUrl, query) {
    const url = typeof propUrl ? propUrl.src : propUrl;
    const urlParts = url ? url.split('?') : propUrl.split('?');
    const baseUrl = urlParts[0];
    const queryString = urlParts[1] || '';

    const extensionMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif|bmp|tiff)$/i);
    if (!extensionMatch) {
        throw new Error('The URL does not contain a valid image extension.');
    }

    const extensionIndex = extensionMatch.index;
    const modifiedBaseUrl = `${baseUrl.slice(0, extensionIndex)}_${query}${baseUrl.slice(extensionIndex)}`;

    return queryString ? `${modifiedBaseUrl}?${queryString}` : modifiedBaseUrl;
}